export const FETCH_AGENT_PREFERENCES =
  'agentPreferences/FETCH_AGENT_PREFERENCES'

export const UPDATE_AGENT_PREFERENCES =
  'agentPreferences/UPDATE_AGENT_PREFERENCES'
